import employers from '@gov.wa.lni/application.warehouse-retaliation/source/data/employers.json';

export default {
    namespaced: 'true',
    state: {
        complaintNumber: '',
        initializeError: 'Please try reloading the page. If the problem persists, please contact Web Customer Support at 360-902-5999 weekdays between 8 a.m.–5 p.m. (Pacific) or  email WebSupport@lni.wa.gov.',
        data: {},
        employer: {
            dba: '',
            entityName: '',
            ubi: '',
            accountID: '',
            contact: '',
            country: '',
            street1: '',
            street2: '',
            city: '',
            state: '',
            zip: '',
            county: '',
            primaryPhone: '',
            alternatePhone: '',
            fax: '',
            primaryEmail: '',
            alternateEmail: '',
        },
        employers,
        formData: null,
        isInitialized: false,
        isLoading: true,
        hasError: false,
        userInput: null,
        customEmployer: true,
        primary: true,
        complaint: {
            list: '',
            other: '',
            explanation: '',
            filed: '',
            describe: '',
            remedy: '',
            agency: '',
            dates:
                {
                    from: '',
                    to: '',
                },

        },
        toggle: true,
        wtdn: '',
        contact: '',
        certify: '',
        documents: '',
    },
    getters: {
        employer: state => state.employer,
        employerOptions(state) {
            return state.employers.map(emp => ({
                text: emp.entityName,
                value: emp.entityName,
            }));
        },
        data: state => key => key ? state.data[key] : state.data,
        isLoading: state => state.isLoading,
        formData(state) {
            return state.formData;
        },
        isInitialized(state) {
            return state.isInitialized;
        },
        wtdn(state) {
            return state.wtdn;
        },
        userData(state) {
            return state.data;
        },
        confirmationText(state) {
            return state.confirmationText;
        },
        userInput(state) {
            return state.userInput;
        },
        hasFormData(state) {
            return !!state.data;
        },
        complaintNumber(state) {
            return state.complaintNumber;
        },
        employerData(state) {
            return state.employerData;
        },
        languages(state) {
            return state.contact.languages;
        },
        contacts(state) {
            return state.contact;
        },
        complaint(state) {
            return state.formData.complaint;
        },
        complaints(state) {
            return state.formData.complaint.list;
        },
        complaintOptions(state) {
            return state.data['complaint.options'];
        },
        confirmation(state) {
            return state.data.confirmation;
        },
        complaintOther(state) {
            return state.complaint.other;
        },
        documents(state) {
            return state.documents;
        },
        certifications(state) {
            return state.certify;
        },
    },
    mutations: {
        RESET_EMPLOYER(state) {
            state.employer = {
                dba: '',
                entityName: '',
                ubi: '',
                accountID: '',
                contact: '',
                country: '',
                street1: '',
                street2: '',
                city: '',
                state: '',
                zip: '',
                county: '',
                primaryPhone: '',
                alternatePhone: '',
                fax: '',
                primaryEmail: '',
                alternateEmail: '',
            };
        },
        SET_VALUE(state, payload) {
            state[payload.key] = payload.value;
        },
        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_COMPLAINT_INFO(state, payload) {
            state.complaintNumber = {
                ...state.complaintNumber,
                ...payload,
            };
        },
    },
};